import React from 'react';
import { FaInstagram, FaLinkedin, FaYoutube, FaTwitter, FaBlogger, FaTiktok } from 'react-icons/fa';
import { TiSocialFacebookCircular } from 'react-icons/ti';

const socialIcons = {
  Instagram: <FaInstagram className='text-xl' />,
  Facebook: <TiSocialFacebookCircular className='text-xl' />,
  Linkedin: <FaLinkedin className='text-xl' />,
  YouTube: <FaYoutube className='text-xl' />,
  Twitter: <FaTwitter className='text-xl' />,
  Blog: <FaBlogger className='text-xl' />,
  TikTok: <FaTiktok className='text-xl' />,
};

export const SocialLinks = ({ socialNetworks, className = 'text-white' }) => {
  return socialNetworks.map((socialNetwork, index) => {
    const IconComponent = socialIcons[socialNetwork.tipoEnlace.descripcion];

    return (
      IconComponent && (
        <div key={`${socialNetwork.valor}-${index}`} className='flex items-center'>
          <a
            href={socialNetwork.valor}
            rel='noopener noreferrer'
            className={`align-center ${className}`}
            target='_blank'
          >
            {React.cloneElement(IconComponent, { className: `text-xl ${className}` })}
          </a>
        </div>
      )
    );
  });
};
